<template>
    <Qalendar
		:selected-date="new Date()"
		:events="events"
		:config="config"
	/>
</template>

<script>
import {Qalendar} from "qalendar";

export default {
    name: 'CalendarWrap',
    components: {
        Qalendar,
    },

    data() {
		return {
			events: [
				{
					id: '1',
					title: "Project Deadline",
					time: { start: "2022-12-05", end: "2022-12-05" },
					isEditable: true,
				},
				{
					id: '2',
					title: "Team Meeting",
					time: { start: "2022-12-11", end: "2022-12-11" },
					isEditable: true,
				},
				{
					id: '3',
					title: "Weekly Meetin",
					time: { start: "2022-12-22", end: "2022-12-22" },
					isEditable: true,
				},
			],

			config: {
				defaultMode: "month",
				style: {
					colorSchemes: {
						meetings: {
							color: "#fff",
							backgroundColor: "#131313",
						},
						sports: {
							color: "#fff",
							backgroundColor: "#ff4081",
						},
					},
				},
			},
		};
	},
}
</script>